// Outcome of one delivery attempt. `pending` is a failed attempt the backend
// will retry, so the same personalization id reports again later; `failed` is
// terminal (retries exhausted).
export type InvestorBulkEmailProgressStatus = 'failed' | 'pending' | 'sent';

// Payload of the per-recipient `progress` event InvestorBulkEmail::Job pushes
// on the channel the modal generated.
export interface InvestorBulkEmailProgressEvent {
  email: string;
  email_personalization_id: string;
  status: InvestorBulkEmailProgressStatus;
}

export interface InvestorBulkEmailFailedRecipient {
  email: string;
  email_personalization_id: string;
}

// One bulk send being tracked (kept after completion until dismissed), keyed
// by its pusher channel.
export interface InvestorBulkEmailSend {
  channel: string;
  complete: boolean;
  dismissed: boolean;
  emailNotificationId?: string;
  failed: InvestorBulkEmailFailedRecipient[];
  fundName: string;
  // sticky: set once any recipient has needed a retry or failed, so the
  // per-status breakdown stays visible even after retries recover
  hadIssues: boolean;
  // recipients whose last attempt failed and are awaiting a retry
  retrying: number;
  sent: number;
  // Unknown until the RPC responds; progress events can arrive before then.
  total?: number;
  vehicleId: string;
}

export const INVESTOR_BULK_EMAIL_PROGRESS_EVENT = 'progress';

// Window over which progress events are folded into a single store update, so
// a burst of thousands of events doesn't thrash change detection.
export const INVESTOR_BULK_EMAIL_BUFFER_MS = 500;

// How long a fully successful send stays on screen after completing. A send
// with failures stays until dismissed, since the card is where they're listed.
export const INVESTOR_BULK_EMAIL_SUCCESS_DISMISS_MS = 6000;
